export default __webpack_public_path__ + "static/media/comments.1da6397e.svg";